// Entry webpack do Painel de Curriculo (antigo): roda no LayoutAntigo, bundle isolado do 'shared'.
import { inicializarInternacionalizacao } from './localizacao/curriculo/curriculo';
import { uploadCurriculo } from './componentes/curriculo/uploads';
import { dadosPessoais } from './componentes/curriculo/dadosPessoais';
import { internacionalizacao } from './componentes/curriculo/internacionalizacao';
import { deletarCurriculo } from './componentes/curriculo/deletarCurriculo';

const curriculo = {
    init: function () {
        if (body.find('#cadastro-curriculo').length > 0) {
            window.global.loaderFull.show();

            uploadCurriculo.init();

            dadosPessoais(true);
            internacionalizacao();
        }
    }
};

inicializarInternacionalizacao();
// chamado aqui (nao self-init no modulo) por causa de sideEffects:false no package.json
deletarCurriculo.init();
curriculo.init();
